import { Button, Drawer } from "antd";
import style from "./index.module.scss";
import React, { useMemo, useState } from "react";
import { DrawerProps } from "antd/es/drawer";
import useRequest from "utils/useRequest";
import { getStudPaper } from "service/homework";
import PageHomeworkDetailRows from "../../index";
import classNames from "classnames";

interface DrawerModalProps extends DrawerProps {
    paperId: string; //试卷id
    studentId: string; //学生id
    studentNo: string; //学号
    onCancel: () => void; //关闭弹窗
    updateData: () => void; //更新列表
    oldScore: number; //原总分
}
export function DrawerModal({
    paperId,
    studentId,
    studentNo,
    onCancel,
    updateData,
    oldScore,
    ...reset
}: DrawerModalProps) {
    const [score, setScore] = useState(0);
    const [data, { loading }] = useRequest(
        () => getStudPaper({ paperId, studentId }),
        {},
        [paperId, studentId]
    );

    const Title = (
        <div>
            <div className={style.name}>
                {data?.studentName} {studentNo}
            </div>
            <div className={style.time}>提交时间 {data?.endTime}</div>
        </div>
    );

    //关闭弹窗并更新列表数据
    const onClose = () => {
        onCancel();
        updateData();
    };

    const disabled = useMemo(() => {
        return oldScore >= 0;
    }, [oldScore]);

    return (
        <div className={style.root}>
            <Drawer
                title={Title}
                width={720}
                onClose={onClose}
                {...reset}
                className={classNames(style.drawer)}>
                <div className={classNames(disabled && style.disabled)}>
                    <PageHomeworkDetailRows
                        paperId={paperId}
                        studentId={studentId}
                        scoreHandler={setScore}
                        data={data}
                        loading={loading}
                    />
                </div>

                <div className={style.footer}>
                    <div className={style.score}>总分：{score}分</div>
                    <div>
                        <Button type="primary" onClick={onClose}>
                            关闭
                        </Button>
                    </div>
                </div>
            </Drawer>
        </div>
    );
}
